type DeepStringRecord<T> = {
  [K in keyof T]: T[K] extends string ? string : DeepStringRecord<T[K]>
}

export const enMessages = {
  errors: {
    code: {
      not_found: 'The requested item could not be found.',
      unauthorized: 'Your session has expired. Please sign in again.',
      forbidden: 'You do not have permission to perform this action.',
      rate_limited: 'Too many requests. Please wait a moment and try again.',
      conflict: 'This action conflicts with existing data.',
      internal_error: 'Something went wrong on our side. Please try again later.',
      validation_error: 'Please check your input and try again.',
      field_owned_by_hr: 'This field is maintained by HR and cannot be changed here.',
      salary_locked_by_pay_run: 'Salary is locked while a pay run is in progress.',
      payroll_identity_locked_for_edit:
        'Employee case is locked. Unlock via admin payroll, or ask an admin for locked-case edit permission, before changing HR record fields.',
      client_not_active_for_assignment:
        'This client is not Active yet. Open Manage Clients, complete setup, and click Activate before assigning employees.',
      workforce_role_code_exists:
        'That role code is already in use. Pick a different code or use the existing role from the list.',
      unknown: 'Something went wrong. Please try again.',
    },
    reference: 'Ref: {{ref}}',
    boundary: {
      title: 'Something went wrong',
      description: 'An unexpected error occurred. You can return to the home page and try again.',
      home: 'Go to home',
    },
  },
} as const

export type Messages = DeepStringRecord<typeof enMessages>
